import React from 'react';

const MenuItems = () => {
  return (
    <>
        <li className="rounded-md font-medium"><a href="/#">Home</a></li>
        <li className="rounded-md font-medium"><a href="/#about">About</a></li>
        <li className="rounded-md font-medium"><a href="/#skills">Skills</a></li>
        <li className="rounded-md font-medium"><a href="/#experience">Experience</a></li>
        <li className="rounded-md font-medium"><a href="/#projects">Projects</a></li>
    </>
  );
}

export default MenuItems;